export const EmptyState: React.FC = () => (
  <div className="flex h-full items-center justify-center text-gray-500">
    <p>Start a conversation with the AI assistant!</p>
  </div>
);
